import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';
import Api from 'api';
import { patchTodosReadNews } from 'actions';
import NewsComponent from '../components/index';

class NewsContainer extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      error: false,
      news: null,
    };
  }

  async componentDidMount() {
    const { params } = this.props.match;

    this.fetchNews(parseInt(params.id, 10));
  }

  fetchNews = async (id) => {
    this.setState({ loading: true });

    try {
      const data = await Api.fetchNewsDetail(id);

      this.setState({
        news: data,
      });
      this.props.patchTodosReadNews(id);
    } catch (err) {
      Sentry.captureException(err);

      this.setState({ error: true });
    }

    this.setState({ loading: false });
  };

  render() {
    const { loading, error, news } = this.state;

    return (
      <NewsComponent
        {...{
          news,
          loading,
          error,
        }}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  patchTodosReadNews: (id) => dispatch(patchTodosReadNews(id)),
});

NewsContainer.propTypes = {
  patchTodosReadNews: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

export default connect(null, mapDispatchToProps)(NewsContainer);
